import { UserProfile } from '@uplift/api';
import { User } from '@uplift/types';

export const formatReferrerNameWithCredentials = (user: User, profile: UserProfile): string => {
  if (!profile || !user) {
    return '';
  }

  const fullNameWithPrefix = `${profile.prefix || ''} ${user.firstName} ${user.lastName}`.trim();
  const suffixes = (profile.suffixes?.length ?? 0) > 0
    ? `, ${profile.suffixes?.join(', ')}`
    : '';
  const title = profile.title ? `, ${profile.title}` : '';

  return `${fullNameWithPrefix}${suffixes}${title}`.trim();
};
